export default __webpack_public_path__ + "static/media/facebook-black.5e77fdf6.svg";